import React, { useMemo } from 'react';
import type { MotionElement, MotionScene } from '@/lib/motion';
import { useLayerFont } from '@/hooks/use-layer-font';

function FontLoader({ font, fontUrl }: { font: string; fontUrl?: string }) {
  useLayerFont(!fontUrl && /^(Georgia|Times New Roman|serif|sans-serif|monospace)$/i.test(font) ? undefined : font, fontUrl);
  return null;
}

/** Load each scene font once, including captions not visible on the current frame. */
export function MotionFonts({ scene }: { scene: MotionScene }) {
  const fonts = useMemo(() => {
    const unique = new Map<string, { font: string; fontUrl?: string }>();
    const add = (font?: string, fontUrl?: string) => {
      if (font) unique.set(`${font}|${fontUrl ?? ''}`, { font, fontUrl });
    };
    const visit = (elements: MotionElement[]) => {
      for (const element of elements) {
        add(element.font, element.fontUrl);
        element.tiers?.forEach((tier) => add(tier.font ?? element.font, tier.fontUrl ?? element.fontUrl));
        if (element.children) visit(element.children);
      }
    };
    visit(scene.elements);
    return [...unique.entries()];
  }, [scene]);
  return <>{fonts.map(([key, font]) => <FontLoader key={key} {...font} />)}</>;
}
